module.exports = __webpack_public_path__ + "static/media/taskInprogress.2e6f7206.svg";